const LOCALE_MAP: Record<string, string> = { fr: 'fr-FR', en: 'en-US' };

function resolveLocale(language: string): string {
    return LOCALE_MAP[language] ?? LOCALE_MAP.fr;
}

// "13 October 2026" / "13 octobre 2026" -- used for race dates.
export function formatLongDate(dateString: string, language: string): string {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString(resolveLocale(language), { day: 'numeric', month: 'long', year: 'numeric' });
}

// "10/13/2026" / "13/10/2026" -- used for compact table cells.
export function formatShortDate(dateString: string, language: string): string {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString(resolveLocale(language));
}

// "10/13/2026, 08:00 AM" / "13/10/2026 08:00" -- used for training start times.
export function formatDateTime(dateString: string, language: string): string {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return new Intl.DateTimeFormat(resolveLocale(language), {
        hour: '2-digit',
        minute: '2-digit',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
}

// "08:00 AM" / "08:00" -- used for training durations.
export function formatTime(dateString: string, language: string): string {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return new Intl.DateTimeFormat(resolveLocale(language), { hour: '2-digit', minute: '2-digit' }).format(date);
}
